import React from 'react';
import { DensityMapControlsProps } from '.';

export const DensityMapControlsContext = React.createContext<DensityMapControlsProps | undefined>(undefined);